import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from 'app/services/meta.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'api-versions-convergence',
  templateUrl: './api-versions-convergence.component.html',
  standalone: false,
})
export class APIVersionsConvergenceComponent implements OnInit, OnDestroy {
  pageRoute: string;
  versions = [];
  versionItemsJson: string = '[]';
  selectedVersionJson: string = '[]';
  mostRecentVersion = true;
  metaSubscription: Subscription;

  @Input() sampleVersions;

  constructor(private metaService: MetaService, private router: Router) {}

  ngOnInit() {
    this.metaSubscription = this.metaService.metadata.subscribe((metadata) => {
      this.setVersions();
    });
  }

  private getBaseSpecRoute(): string {
    let cleanedRoute = this.router.url.split('#')[0];
    if (this.metaService.metadata.value.versions) {
      for (const version of this.metaService.metadata.value.versions) {
        const versionWithDashes = version.split('.').join('-');
        if (cleanedRoute.includes('/' + version)) {
          cleanedRoute = cleanedRoute.replace('/' + version, '');
        }
        if (cleanedRoute.includes('/' + versionWithDashes)) {
          cleanedRoute = cleanedRoute.replace('/' + versionWithDashes, '');
        }
      }
    }
    return cleanedRoute;
  }

  setVersions() {
    this.versions = [];
    // removed from input pram as it was not getting refreshed on sec nav link click
    this.pageRoute = this.router.url;
    this.pageRoute && this.pageRoute.split('/').pop() === 'api-specification'
      ? (this.mostRecentVersion = true)
      : (this.mostRecentVersion = false);
    let route;
    // eslint-disable-next-line guard-for-in
    if (this.metaService.metadata.value.versions) {
      for (const x of this.metaService.metadata.value.versions) {
        if (this.metaService.metadata.value['apimatic-spec']) {
          if (x.toLowerCase() === this.metaService.metadata.value.versions[0]) {
            route = this.getBaseSpecRoute();
          } else {
            if (this.metaService.metadata.value['new-onboarding']) {
              route = this.getBaseSpecRoute() + '/' + x.split('.').join('-');
            } else {
              route =
                this.router.url.split('#')[0].replace('api-specification', 'apis') +
                '/' +
                'api-specification' +
                '/' +
                x.split('.').join('-');
            }
          }
        } else {
          if (x.toLowerCase() === this.metaService.metadata.value.versions[0]) {
            route = '/' + this.pageRoute.match(/.*(\/api-specification)/g)[0];
          } else {
            route = '/' + this.pageRoute.match(/.*(\/api-specification)/g)[0] + '/' + x.split('.').join('-');
          }
        }
        this.versions.push({
          name: x,
          route: route,
        });
      }
    } else {
      this.versions = this.sampleVersions || [];
    }
    if (!this.versions?.length) {
      this.versionItemsJson = '[]';
      this.selectedVersionJson = '[]';
      return;
    }
    this.versions[0].name = this.versions[0].name + ' Latest';
    const items = this.versions.map(v => ({ label: v.name, value: v.name }));
    this.versionItemsJson = JSON.stringify(items);
    this.selectedVersionJson = JSON.stringify([items[0]?.value]);
  }

  onVersionChange(event: any): void {
    if (!this.versions?.length) {
      return;
    }
    const selectedValue = event.detail?.values?.[0] || event.detail?.value;
    if (selectedValue) {
      if (selectedValue === this.versions[0].name && this.mostRecentVersion) {
        return;
      }
      const version = this.versions.find(v => v.name === selectedValue);
      if (version?.route) {
        this.router.navigateByUrl(version.route);
      }
    }
  }


  ngOnDestroy(): void {
    if (this.metaSubscription) {
      this.metaSubscription.unsubscribe();
    }
  }
}
